import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { loadConfig } from './config/add-in-config';

Office.onReady(async () => {
  try {
    if (new URLSearchParams(window.location.search).get('dialog') === 'progress') {
      const { ProgressModule } = await import('./foundry-excel/progress/progress.module');
      await platformBrowserDynamic().bootstrapModule(ProgressModule);
      return;
    }
    if (new URLSearchParams(window.location.search).get('dialog') === 'entity-filter') {
      const { EntityFilterModule } = await import('./foundry-excel/entity-filter/entity-filter.module');
      await platformBrowserDynamic().bootstrapModule(EntityFilterModule);
      return;
    }
    await loadConfig();
    const { AppModule: module } = await import('./foundry-excel/app.module');
    await platformBrowserDynamic().bootstrapModule(module);
  } catch (error) {
    console.error(error);
    const root = document.querySelector('app-root');
    if (root) root.textContent = `Unable to start add-in: ${error instanceof Error ? error.message : String(error)}`;
  }
});
